import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

export default function BookingCancel() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-[#050505] pt-24 pb-12" data-testid="booking-cancel">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <Card className="bg-zinc-900/50 border-white/10 p-6 sm:p-10 text-center">
          <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-12 w-12 text-red-500" />
          </div>

          <h1 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
            {t('bookingCancel.title')}
          </h1>

          <p className="text-zinc-400 mb-8">
            {t('bookingCancel.desc')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate(-1)}
              className="bg-[#F9004D] hover:bg-[#D00040] text-white"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              {t('bookingCancel.retry')}
            </Button>
            <Button
              onClick={() => navigate('/hosts')}
              variant="outline"
              className="border-white/20 text-white hover:bg-white/10"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              {t('bookingCancel.back')}
            </Button>
          </div>

          <p className="text-zinc-500 text-sm mt-8">
            {t('bookingCancel.help')}
          </p>
        </Card>
      </div>
    </div>
  );
}
